/** @format */

import React, { useState, useEffect } from "react";
import "./index.scss";
import SiTable from "../../../common-utilities/core/table";
import { getHeaderConfig, getMobileHeaderConfig } from "./config";
import Button from "@mui/material/Button";
import CustomModal from "../../../common-utilities/core/modal";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/cf-approval";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { toast } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { userTypes } from "../../utils/constants";

const Users = () => {
  const [users, setUsers] = useState({});
  const [addUser, setAddUser] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [createStoreButton, setcreateStoreButton] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sortBy: "-createdAt",
  });
  const loadData = (params) => {
    const userFilter = typeof params === "object" ? { ...params } : filters;
    if (!userFilter.limit) {
      userFilter.limit = filters.limit;
    }
    if (!userFilter.page) {
      userFilter.page = filters.page;
    }
    if (!userFilter.sortBy) {
      userFilter.sortBy = filters.sortBy;
    }
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_USERS}`,
      null,
      userFilter
    )
      .then((response) => {
        if (response) {
          setUsers(response);
        }
      })
      .catch((err) => {
        toast.error("Failed to load Users");
      });
  };

  useEffect(() => {
    loadData(filters);
  }, [filters]);
  function capitalizeFirstLetter(string) {
    if (string.length) {
      return string[0].toUpperCase() + string.slice(1);
    }
  }
  const addUserFormHandler = () => {
    setAddUser(true);
  };
  const addNameHandler = (event) => {
    let name = capitalizeFirstLetter(event.target.value);
    setName(name);
  };
  const addEmailHandler = (event) => {
    setEmail(event.target.value);
  };
  const formSubmitHandler = () => {
    let payload = {
      name: name,
      email: email,
    };
    if (isAdmin) {
      payload.role = userTypes.admin;
    }
    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.INVITE_USER}`, payload)
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          loadData(filters);
          setName("");
          setEmail("");
          setAddUser(false);
        }
      })
      .catch((err) => {
        toast.error("Failed to Invite");
      });
    setAddUser(false);
  };

  const setAdminHandler = (_) => {
    setIsAdmin(!isAdmin);
  };
  return (
    <>
      <div className="user-container">
        {createStoreButton && (
          <div className="button-div">
            <Button
              size="medium"
              variant="contained"
              className="button"
              onClick={addUserFormHandler}
            >
              Invite User
            </Button>
          </div>
        )}

        <div className="si-hide-mobile">
          <SiTable
            header={getHeaderConfig(loadData)}
            data={users.results || []}
            pageCount={users.totalPages}
            filters={filters}
            onChange={(event, page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
          ></SiTable>
        </div>
        <div className="si-hide-web">
          <SiTable
            header={getMobileHeaderConfig(null)}
            data={users.results || []}
            pageCount={users.totalPages}
            filters={filters}
            onChange={(event, page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
          ></SiTable>
        </div>
      </div>
      {addUser && (
        <CustomModal
          title="Invite User"
          contentClassName={{ headerBackgroundColor: "#008938" }}
          onClose={() => {
            setAddUser(false);
            setName("");
            setEmail("");
            setIsAdmin(false);
          }}
        >
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="name"
              sx={{ my: 1 }}
              label="Name"
              multiline
              onChange={addNameHandler}
              value={name}
              size="small"
            />
            <TextField
              fullWidth
              id="email"
              sx={{ my: 1 }}
              label="Email"
              onChange={addEmailHandler}
              value={email}
              type="email"
              size="small"
            />

            <FormControlLabel
              label="Is admin"
              control={
                <Checkbox checked={isAdmin} onChange={setAdminHandler} />
              }
            />

            <Stack direction="row" spacing={2} sx={{ my: 2 }}>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={formSubmitHandler}
                fullWidth
              >
                Invite
              </Button>
              <Button
                variant="outlined"
                className="outlined-btn"
                size="medium"
                onClick={() => {
                  setAddUser(false);
                  setName("");
                  setEmail("");
                }}
                fullWidth
              >
                Cancel
              </Button>
            </Stack>
          </Box>
        </CustomModal>
      )}
    </>
  );
};

export default Users;
